import { useQuery } from "@tanstack/react-query";
import { FetchBookings, fetchBookings } from "PFApp/booking/services/api";
import { Booking, PaginatedCollection, QueryOptions } from "PFTypes";

import { bookingKeys } from "./query_keys";

export const useBookings = (params: FetchBookings, options?: QueryOptions<PaginatedCollection<Booking[]>>) =>
  useQuery<PaginatedCollection<Booking[]>>(bookingKeys.list(params), () => fetchBookings(params), options);
